<div class="sidenav">
  <button *ngFor="let button of buttons" (click)="toggleContent(button.id)"
    [class.active]="activeContent === button.id">
    {{ button.label }}
  </button>
</div>
<div class="main">
  <ng-container *ngFor="let button of buttons">
    <div [id]="button.id" *ngIf="activeContent === button.id">
      <app-mwe-table 
        [columns]="columns" 
        [data]="Data" 
        [title]="button.label"  
        [showAddButton]="hasAddPermission"
        [showAddButtonName]="'Add ' + button.id"
        [showFilter]="false" 
        [showMasterDataSearch]="button.id !== 'Support Issue' && button.id !== 'Support Priority' && button.id !== 'Department'" 
        [showSearch]="button.id === 'Support Issue' || button.id === 'Support Priority' || button.id === 'Department'"
        [showPagination]="true" 
        (selectedAction)="selectedAction($event)" 
        (pageChanged)="onPageChanged($event)" 
        (applyyFilter)="applyFilter($event)"   
        [currentPageChanged]="pageIndex" 
        [masterDataSearch]="startsWith" 
        [dynamicPageSize]="pageSize" 
        [isDynemicPagination]="isDynemicPagination"
        [totalEntries]="totalEntries"
        (searchTerm)="searchTermMethod($event)">
      </app-mwe-table>
    </div>
  </ng-container>
</div>
 